export default "__VITE_ASSET__Cvk56Ofz__"